import { render, staticRenderFns } from "./person_change_detail_m.vue?vue&type=template&id=6453115b&scoped=true&"
import script from "./person_change_detail_m.vue?vue&type=script&lang=js&"
export * from "./person_change_detail_m.vue?vue&type=script&lang=js&"
import style0 from "./person_change_detail_m.vue?vue&type=style&index=0&id=6453115b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453115b",
  null
  
)

export default component.exports